import type { SVGProps } from "react";

export default function CynthaiLogo(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3454_10204)">
        <circle cx="17.1" cy="18.9" r="13.275" fill="white" />
        <path
          d="M35.3544 13.2255C36.4951 17.3716 36.1159 21.7869 34.2831 25.6753C32.4504 29.5636 29.2859 32.6674 25.3628 34.4277C21.4397 36.1881 17.0157 36.4805 12.8928 35.2616C8.76988 34.0426 5.22315 31.3848 2.88665 27.7743C0.550158 24.1639 -0.413973 19.8384 0.165084 15.5794C0.744142 11.3175 2.82875 7.4089 6.03962 4.55125C9.25339 1.6936 13.3821 0.0780282 17.6787 -0.000144583C21.9782 -0.075422 27.1028 1.69649 30.719 5.78753C30.719 5.78753 28.1104 15.2088 28.1075 15.2175C28.261 14.6674 27.4734 13.2458 27.2447 12.7594C26.7091 11.6157 25.9679 10.5705 25.0066 9.7425C21.1617 6.4216 14.7255 6.89353 11.0369 10.1681C9.16364 11.83 7.95051 14.1115 7.61466 16.5899C7.27591 19.0711 7.84049 21.5871 9.19838 23.692C10.1538 25.1715 11.4625 26.3759 12.9912 27.204L11.6941 30.522L19.523 28.3679C20.4697 28.2318 21.3991 27.9625 22.2851 27.5659C24.5666 26.541 26.4138 24.7343 27.4763 22.4702C28.5447 20.2061 28.7676 17.635 28.1017 15.2204L35.3515 13.2255H35.3544Z"
          fill="url(#paint0_radial_3454_10204)"
        />
        <path
          d="M11.6971 30.5222L11.0225 25.8174C11.0225 25.8174 12.1545 26.8018 12.9942 27.2042L11.6971 30.5222Z"
          fill="#B16207"
        />
        <path
          d="M35.3543 13.2257L29.1207 11.5522L28.1045 15.2206"
          fill="#B16207"
        />
        <path
          d="M14.132 18.0003C14.7604 18.0003 15.2698 17.4909 15.2698 16.8625C15.2698 16.234 14.7604 15.7246 14.132 15.7246C13.5036 15.7246 12.9941 16.234 12.9941 16.8625C12.9941 17.4909 13.5036 18.0003 14.132 18.0003Z"
          fill="#011E41"
        />
        <path
          d="M22.2184 18.0003C22.8468 18.0003 23.3563 17.4909 23.3563 16.8625C23.3563 16.234 22.8468 15.7246 22.2184 15.7246C21.59 15.7246 21.0806 16.234 21.0806 16.8625C21.0806 17.4909 21.59 18.0003 22.2184 18.0003Z"
          fill="#011E41"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_3454_10204"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.0005 17.9996) rotate(90) scale(18.0021 17.9995)"
        >
          <stop stopColor="#8F6200" />
          <stop offset="0.69" stopColor="#F5A800" />
        </radialGradient>
        <clipPath id="clip0_3454_10204">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
